/*jshint esversion: 6 */
// import store from '@/store/index';

function Template(payload) {
  let route = {
    path: 'takt/:takt_index',
    name: 'ProjectWalletTakt',
    components: {
      left: () => import( /* webpackChunkName: "Project" */ '@/views/Project/ProjectWallet/ProjectWalletTaktRework.view.vue'),
      center: () => import( /* webpackChunkName: "Project" */ '@/views/Project/ProjectWallet/ProjectWalletTaktRework.view.vue'),
      right: () => import( /* webpackChunkName: "Project" */ '@/views/Project/ProjectWallet/ProjectWalletTaktRework.view.vue'),
    },
    meta: {
      requiresAuth: true
    },
    props: {
      left: (route) => {
        return {
          project_id: parseInt(route.params.project_id),
          takt_index: parseInt(route.params.takt_index) - parseInt(1),
          tworkpackage_id: parseInt(route.params.tworkpackage_id),
          work_card_id: parseInt(route.params.work_card_id),
          quality_card_id: parseInt(route.params.quality_card_id),
          defect_card_id: parseInt(route.params.defect_card_id),
          handover_card_id: parseInt(route.params.handover_card_id),
          logistic_card_id: parseInt(route.params.logistic_card_id),
          design_card_id: parseInt(route.params.design_card_id),
          selected_column: route.params.selected_column,
          wallet_column: 'left',
        };
      },
      center: (route) => {
        return {
          project_id: parseInt(route.params.project_id),
          takt_index: parseInt(route.params.takt_index),
          tworkpackage_id: parseInt(route.params.tworkpackage_id),
          work_card_id: parseInt(route.params.work_card_id),
          quality_card_id: parseInt(route.params.quality_card_id),
          defect_card_id: parseInt(route.params.defect_card_id),
          handover_card_id: parseInt(route.params.handover_card_id),
          logistic_card_id: parseInt(route.params.logistic_card_id),
          design_card_id: parseInt(route.params.design_card_id),
          selected_column: route.params.selected_column,
          wallet_column: 'center',
        };
      },
      right: (route) => {
        return {
          project_id: parseInt(route.params.project_id),
          takt_index: parseInt(route.params.takt_index) + parseInt(1),
          tworkpackage_id: parseInt(route.params.tworkpackage_id),
          work_card_id: parseInt(route.params.work_card_id),
          quality_card_id: parseInt(route.params.quality_card_id),
          defect_card_id: parseInt(route.params.defect_card_id),
          handover_card_id: parseInt(route.params.handover_card_id),
          logistic_card_id: parseInt(route.params.logistic_card_id),
          design_card_id: parseInt(route.params.design_card_id),
          selected_column: route.params.selected_column,
          wallet_column: 'right',
        };
      },
    },
  };
  if (payload && payload.children) {
    route.children = payload.children;
  }
  return route;
}
export default Template;
